/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Note } from '../../models/note';
import { NoteCreateDto } from '../../models/note-create-dto';

export interface CreateNote$Params {
  entityId: string;
  entityClass: 'Form' | 'FormQualitySection';
  body: NoteCreateDto;
}

export function createNote(
  http: HttpClient,
  rootUrl: string,
  params: CreateNote$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Note>> {
  const rb = new RequestBuilder(rootUrl, createNote.PATH, 'post');
  if (params) {
    rb.path('entityId', params.entityId, {});
    rb.path('entityClass', params.entityClass, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Note>;
    })
  );
}

createNote.PATH = '/notes/{entityClass}/{entityId}';
